export enum InvoiceAggregationStatus {
  FROZEN = 'FROZEN',
  SENDING_FAILED = 'SENDING_FAILED',
  SUCCESSFULLY_SENT = 'SUCCESSFULLY_SENT',
}
